import Color from './Color.vue'
import Item from './Item.vue'
import Link from './Link.vue'

export default {
  Color,
  Item,
  Link,
}
